/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SeaShoreLocationDTO = {
    SEA: 'SEA',
    SHORE: 'SHORE'
} as const;
export type SeaShoreLocationDTO = typeof SeaShoreLocationDTO[keyof typeof SeaShoreLocationDTO];

